import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";
import sendRequest from "../../../helpers/requestHelper";

const myCompanyDataSave = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        modalData: {},
        isCompanySave: false,
    },
    mutations: {
        DATA_SAVE_SUCCESS(state, response) {
            eventBus.$emit("storeDataSuccess");
            state.modalData.textInfoCompanySave = response.data.data.textInfo;
            state.modalData.headInfoCompanySave = response.data.message;
            state.modalData.typeInfoCompanySave = "green";
            localStorage.setItem("companyFirstName", response.data.data.companyData.firstname);
            localStorage.setItem("companyLastName", response.data.data.companyData.lastname);
            localStorage.setItem("companyName", response.data.data.companyData.name);
            localStorage.setItem("companyIsVatPayer", response.data.data.companyData.isVatPayer);

            eventBus.$emit("updateMyCompany");
            state.isCompanySave = true;
        },
        DATA_SAVE_FAILURE(state, error) {
            eventBus.$emit("storeDataFailure", error.response.data.errors);
            state.modalData.textInfoCompanySave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.modalData.typeInfoCompanySave = "red";
            state.modalData.headInfoCompanySave = error.response.data.message;
            state.isCompanySave = true;
        },
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isCompanySave = value;
        }
    },
    actions: {
        storeData: function ({ dispatch, state }, payload) {
            dispatch("requestDataSave", true);
            var promise = sendRequest("post", config.baseURLApi+"/user-company", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
                state.dataSaveIsFetching = false;
            });
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataSave: function ({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function ({commit}, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModal: function(context, value) {
            context.commit('UPDATE_VISIBLE_MODAL', value);
        }
    }
}

export default myCompanyDataSave;